import React, { useEffect } from 'react';
import useProductPrice from '../../../hooks/useProductPrice';
import { withError } from '../../../shared/components/error-boundary';

import './dynamic-sale-message.less';

/***
 * This component will find the largest discount on the active tab
 * then it will add the discount to the innerHTML of all elements with the class dynamicSavingsContainer
 */
export default withError(({ activePG }) => {
    const { key, products } = activePG;
    const { prices } = useProductPrice(products, { returnEmptyPriceObj: false });

    useEffect(() => {
        let biggestDiscount = 0;
        Object.keys(prices).forEach(sku => {
            const price = prices[sku];
            if (price && !price.isOOS && price.discountPercent > biggestDiscount) {
                biggestDiscount = Math.floor(price.discountPercent);
            }
        });
        if (biggestDiscount > 0) {
            setTimeout(() => {
                const dynamicSavingsContainers = document.getElementsByClassName('slpDSCtr');
                for (let i = 0; i < dynamicSavingsContainers.length; i++) {
                    dynamicSavingsContainers[i].innerHTML = biggestDiscount;
                }
            }, 500);
        }
    }, [key, prices]);
    return null;
});
